import { useState } from "react";
import { MenuItem, Popover, Button, Stack } from "@mui/material";
import { DensityMedium } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { useSetRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";
import { authState } from "../../recoil/authState";
import PasswordChangeDialog from "./PasswordChangeDialog";

export default function UserMenu() {
  const theme = useTheme();
  const setAuth = useSetRecoilState(authState);
  const navigate = useNavigate();
  const [open, setOpen] = useState(null);
  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const logoutHandle = () => {
    setAuth({
      isLoggedIn: false,
      user: null,
      token: null,
    });
    localStorage.clear();
    navigate("login");
    handleClose();
  };

  const handlePasswordChangeClick = () => {
    setPasswordDialogOpen(true);
    handleClose();
  };

  return (
    <>
      <Stack display={"flex"} flexDirection={"row"} alignItems={"center"}>
        <Button
          onClick={handleOpen}
          size="small"
          sx={{
            mt: "2px",
            minWidth: "0px !important",
            width: "30px !important",
          }}
        >
          <DensityMedium
            fontSize="20px"
            sx={{
              color: theme.palette.common.darkGrey,
              verticalAlign: "middle",
            }}
          />
        </Button>

        <Popover
          open={!!open}
          anchorEl={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem
            disableRipple
            disableTouchRipple
            onClick={handlePasswordChangeClick}
            sx={{
              typography: "body2",
              py: 1.5,
              display: "flex",
              justifyContent: "Center",
            }}
          >
            비밀번호 변경
          </MenuItem>
          <MenuItem
            disableRipple
            disableTouchRipple
            onClick={logoutHandle}
            sx={{
              typography: "body2",
              color: "error.main",
              py: 1.5,
              display: "flex",
              justifyContent: "Center",
            }}
          >
            로그아웃
          </MenuItem>
        </Popover>
      </Stack>
      <PasswordChangeDialog
        open={passwordDialogOpen}
        onClose={() => setPasswordDialogOpen(false)}
      />
    </>
  );
}
